import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'CLUSTER_TYPE_MONITORING_SERVICES',
    itemActionName: 'CLUSTER_TYPE_MONITORING_SERVICE',
});
